/* layer DOM element */
const layer_element = {
    "#layer-awards-my":`
            <table>
            <thead>
            <tr>
                <th>공훈 구분</th>
                <th>기록 기준</th>
                <th>공훈 표기 기준</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th>공통</th>
                <td>2020. 11. 11.(수) 서버 오픈 후 ~ 2021. 11. 10.(수) 정기점검 전까지의 계정 내 모든 캐릭터의 기록의 합</td>
                <td></td>
            </tr>
            <tr>
                <th>아트레이아와 함께</th>
                <td>아이온 클래식에 접속한 날짜 캐릭터 접속일 기준 00시 ~ 23시 59분 59초 내에 접속해 있는 경우 1일로 체크 (접속 중 00시가 넘은 경우에도 1일로 체크, 계정 내 캐릭터 1회만 체크)</td>
                <td>300일 이상 : 백금 공훈, 299 ~ 200일 : 청금 공훈, 199일 ~ 100일 : 금 공훈, 99일 이하 은 공훈</td>
            </tr>
            <tr>
                <th>PVP-어비스</th>
                <td>어비스 지역에서 PVP를 진행한 횟수 (상대 종족을 KILL하여 AP를 획득한 경우 1회로 체크)</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>PVP-필드</th>
                <td>인테르디카, 벨루스란 지역에서 PVP를 진행한 횟수 (상대 종족을 KILL하여 AP를 획득한 경우 1회로 체크)</td>
                <td>각 구분별 순위 기준 : 상위 20% : 백금 공훈, 상위 21% 이상 ~  40% : 청금 공훈, 상위 41% 이상 ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>요새전</th>
                <td>요새전에 참여하여 총사령관의 포상으로 금/은 공훈 훈장을 획득한 수량 (금 공훈 훈장은 1개당 3점, 은 공훈 훈장은 1개당 1점으로 계산하여 총점으로 순위 산정)</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>드레드기온 획득 AP</th>
                <td>드레드기온 입장 후 종료 시 획득한 AP의 합산 값</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>타하바타 공략</th>
                <td>암흑의 포에타 화염의 지배자 타하바타를 공략한 횟수 (타하바타 공략 시점에 사망한 경우 포함되지 않음)</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>바카르마 공략</th>
                <td>드라웁니르 동굴 군단장 바카르마를 공략한 횟수 (바카르마 공략 시점에 사망한 경우 포함되지 않음)</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            <tr>
                <th>시공의 균열</th>
                <td>엘테넨, 인테르디카, 모르헤임, 벨루스란 지역에서 시공의 균열을 이용한 횟수</td>
                <td>각 구분별 순위 기준 : 상위 20% 이상 : 백금 공훈, 상위 21% ~  40% : 청금 공훈, 상위 41% ~  60% : 금 공훈, 상위 61% 이하 : 은 공훈</td>
            </tr>
            </tbody>
            </table>`,
    "#layer-awards-platinum":`
            <table>
            <thead>
            <tr>
                <th>공훈 구분</th>
                <th>공훈 보상</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th>백금 공훈 1개</th>
                <td>[이벤트] 85레벨 강화석 1개</td>
            </tr>
            <tr>
                <th>백금 공훈 2개</th>
                <td>[이벤트] 85레벨 강화석 2개</td>
            </tr>
            <tr>
                <th>백금 공훈 3개</th>
                <td>[이벤트] 85레벨 강화석 3개</td>
            </tr>
            <tr>
                <th>백금 공훈 4개</th>
                <td>[이벤트] 85레벨 강화석 4개</td>
            </tr>
            <tr>
                <th>백금 공훈 5개</th>
                <td>[이벤트] 85레벨 강화석 5개, 최상급 고대의 왕관 1개</td>
            </tr>
            <tr>
                <th>백금 공훈 6개</th>
                <td>[이벤트] 85레벨 강화석 5개, 최상급 고대의 왕관 2개</td>
            </tr>
            <tr>
                <th>백금 공훈 7개</th>
                <td>[이벤트] 85레벨 강화석 5개, 최상급 고대의 왕관 3개</td>
            </tr>
            <tr>
                <th>백금 공훈 8개</th>
                <td>[이벤트] 85레벨 강화석 5개, 최상급 고대의 왕관 4개</td>
            </tr>
            </tbody>
            </table>`,
    "#layer-special":`
            <table>
            <thead>
            <tr>
                <th>구분</th>
                <th>1등 선정 조건</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th colspan="2">공통</th>
                <td>2020년 11월 11일 (수) 서버 오픈 후 ~ 2021년 11월 10일 (수) 정기점검 전까지 캐릭터별 외모 변경/외형 변경 횟수 및 주문서/캔디 사용량 * 캐릭터가 서버 이전을 한 경우 합산되지 않고 각각 별도의 캐릭터로 적용 * 동일한 횟수의 경우 최대 횟수를 빨리 달성한 캐릭터가 1등으로 선정</td>
            </tr>
            <tr>
                <th>아트레이아 패셔니스타</th>
                <th>외모 변경을 가장 많이 한 데바</th>
                <td>외모 변경 횟수가 가장 많은 캐릭터</td>
            </tr>
            <tr>
                <th>아트레이아 패셔니스타</th>
                <th>외형 변경을 가장 많이 한 데바</th>
                <td>외형 변경 횟수가 가장 많은 캐릭터 *옷장 포함</td>
            </tr>
            <tr>
                <th>풀 도핑! 전투 준비 완료</th>
                <th>주문서 사용량이 가장 많은 데바</th>
                <td>용기, 질주, 각성, 광풍, 치명타 향상 주문서 사용량이 가장 많은 캐릭터 *하급, 중급, 상급, 이벤트 아이템 포함</td>
            </tr>
            <tr>
                <th>풀 도핑! 전투 준비 완료</th>
                <th>캔디 사용량이 가장 많은 데바</th>
                <td>각종 캔디 사용량이 가장 많은 캐릭터 *퀘스트 수행에 필요한 캔디 아이템 제외하고 모든 변신 캔디 포함</td>
            </tr>
            </tbody>
            </table>`,
};

export default layer_element;


// WEBPACK FOOTER //
// ./src/js/element/layer_element.js